import { env } from 'process'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export type AuthState = {
  federationToken?: string
  setFederationToken: (federationToken?: string) => void
}

export const useAuthStore = create<AuthState>()(
  devtools(
    (set, get) => ({
      federationToken: undefined,
      setFederationToken: federationToken => {
        set(state => ({
          federationToken,
        }))
      },
    }),
    { name: 'AuthStore', enabled: !env.isProduction },
  ),
)

export const setFederationToken = (federationToken?: string) => {
  return useAuthStore.getState().setFederationToken(federationToken)
}
